import { FiltersTypeImpl } from "@common/utils/filters";
import { Priority } from "@services/common/types";

export const widgetTypes: Filter<UserWidgetType> = [
  { label: "Devices", value: FiltersTypeImpl.Devices },
  { label: "Rooms", value: FiltersTypeImpl.Rooms },
  { label: "Meetings", value: FiltersTypeImpl.Meetings },
  { label: "Tickets", value: FiltersTypeImpl.Tickets },
];

export const meetingsTimeFilter: Filter<MeetingsTimeFilter> = [
  { label: "For the last 24 hours", value: "For the last 24 hours" },
  { label: "For the last 12 hours", value: "For the last 12 hours" },
  { label: "Today", value: "Today" },
  { label: "For the next 12 hours", value: "For the next 12 hours" },
  { label: "For the next 24 hours", value: "For the next 24 hours" },
  { label: "Custom time period", value: "Custom time period" },
];

export const meetingsAssigneeFilter: Filter<MeetingsAssigneeFilter> = [
  { label: "Assigned to Me", value: "ME" },
  { label: "Without Producer", value: "NONE" },
  { label: "Assigned to", value: "ASSIGNED_TO" },
];

export const meetingsPurposeFilter: Filter<MeetingsPurposeFilter> = [
  { label: "Regular", value: "RegularMeeting" },
  { label: "Certification", value: "Certification" },
  { label: "Maintenance", value: "Maintenance" },
  { label: "Room Sweep", value: "Sweep" },
  { label: "Other", value: "Other" },
];
export const ticketsPurposeFilter: Filter<TicketsPurposeFilter> = [
  { label: "Cleared Issues", value: "Cleared Issues" },
  { label: "Open Issues", value: "Open Issues" },
];

export const meetingsTypeFilter: Filter<MeetingsTypeFilter> = [
  { label: "Room Only", value: "RoomOnly" },
  { label: "Point to Point", value: "PointToPoint" },
  { label: "Multipoint", value: "MultiPoint" },
  { label: "Ad Hoc", value: "AdHoc" },
  { label: "EVCS", value: "VMR" },
];

export const meetingsOtherFilter: Filter<MeetingsOtherFilter> = [
  { label: "VIP", value: "VIP" },
  { label: "Full Attendance", value: "FullAttendance" },
  { label: "Greet Participants", value: "GreetParticipant" },
  { label: "Monitor Connections", value: "MonitorConnection" },
];

export const devicesVIPFilter: Filter<DevicesVIPFilter> = [
  { label: "Yes", value: "VIP Devices" },
  { label: "No", value: "Non-VIP Devices" },
];

export const devicesActiveFilter: Filter<DevicesActiveFilter> = [
  { label: "Active Devices", value: "Active Devices" },
  { label: "Inactive Devices", value: "Inactive Devices" },
];

export const devicesSourceFilter: Filter<DevicesSourceFilter> = [
  { label: "Direct", value: "Symphony Direct" },
  { label: "Controller", value: "Room Controller" },
  { label: "Aggregator", value: "3rd Party Management" },
  { label: "DMCA", value: "DMCA" },
];
export const addDevicesSourceFilter: Filter<AddDevicesSourceFilter> = [
  { label: "Direct", value: "Symphony Direct" },
  { label: "Controller", value: "Room Controller" },
  { label: "Aggregator", value: "3rd Party Management" },
  { label: "DMCA", value: "DMCA" },
  {
    label: "Direct & Controller",
    value: "Symphony Direct & Room Controller",
  },
  {
    label: "Direct & Aggregator",
    value: "Symphony Direct & 3rd Party Management",
  },
  {
    label: "Direct & DMCA",
    value: "Symphony Direct & DMCA",
  },
  {
    label: "Aggregator & DMCA",
    value: "3rd Party Management & DMCA",
  },
  {
    label: "Controller & DMCA",
    value: "Room Controller & DMCA",
  },
];

export const devicesServiceFilter: Filter<DevicesServiceFilter> = [
  { label: "None", value: "None" },
  { label: "Basic Monitoring", value: "Ping" },
  { label: "Advanced Monitoring", value: "All" },
];

export const roomsServiceFilter: Filter<RoomsServiceFilter> = [
  { label: "Active", value: "Active" },
  { label: "Not Active", value: "Not Active" },
];

export const roomsVipFilter: Filter<RoomsVIPFilter> = [
  { label: "Yes", value: "VIP Rooms" },
  { label: "No", value: "Non-VIP Rooms" },
];

export const roomsManagementFilter: Filter<RoomsManagementFilter> = [
  { label: "Managed rooms only", value: "Managed rooms only" },
];

export const roomsPublicFilter: Filter<RoomsPublicFilter> = [
  { label: "Public Rooms", value: "Public Room" },
  { label: "Non-Public Rooms", value: "Non-Public Room" },
];
export const ticketsStateFilter: Filter<TicketsStateFilter> = [
  { label: "Open", value: "Open" },
  { label: "Pending Close", value: "ClosePending" },
  { label: "Closed", value: "Closed" },
];
export const ticketsTimeFilter: Filter<TicketsTimeFilter> = [
  { label: "For the last 24 hours", value: "For the last 24 hours" },
  { label: "Today", value: "Today" },
  { label: "Custom time period", value: "Custom time period" },
];
export const devicesWarrantyExpirationTimeFilter: Filter<DevicesWarrantyExpirationTimeFilter> =
  [
    { label: "Today", value: "Today" },
    { label: "In the next week", value: "In the next week" },
    { label: "In the next month", value: "In the next month" },
    { label: "In the next 3 months", value: "In the next 3 months" },
    { label: "Custom time period", value: "Custom time period" },
  ];
export const devicesLeaseExpirationTimeFilter: Filter<DevicesLeaseExpirationTimeFilter> =
  [
    { label: "Today", value: "Today" },
    { label: "In the next week", value: "In the next week" },
    { label: "In the next month", value: "In the next month" },
    { label: "In the next 3 months", value: "In the next 3 months" },
    { label: "Custom time period", value: "Custom time period" },
  ];
export const roomsServiceExpirationTimeFilter: Filter<RoomsServiceExpirationTimeFilter> =
  [
    { label: "Today", value: "Today" },
    { label: "In the next 48 hours", value: "In the next 48 hours" },
    { label: "In the next week", value: "In the next week" },
    { label: "In the next month", value: "In the next month" },
    { label: "Custom time period", value: "Custom time period" },
  ];
export const auditTimeFilter: Filter<AuditTimeFilter> = [
  { label: "Today", value: "Today" },
  { label: "This week", value: "This week" },
  { label: "This month", value: "This month" },
  { label: "Custom time period", value: "Custom time period" },
];
export const assignedToFilter: Filter<TicketsAssignedToFilter> = [
  { label: "Assigned to", value: "Assigned to" },
  { label: "Assigned to Me", value: "Assigned to Me" },
  { label: "Unassigned", value: "unassigned" },
];

export const devicesStatusFilter: Filter<DevicesStatusFilter> = [
  // { label: "All", value: "All" },
  { label: "Link Up", value: "Up" },
  { label: "Link Error", value: "Unreachable" },
  { label: "Monitoring Stalled", value: "Monitoring Stalled" },
  { label: "Monitoring Paused", value: "Monitoring Paused" },
  { label: "Monitoring Triggers Paused", value: "Monitoring Triggers Paused" },
  { label: "Unknown", value: "Unknown" },
  { label: "API Error", value: "API Error" },
  { label: "Login Error", value: "Login Error" },
  { label: "In a Call", value: "In a Call" },
];

export const roomsStatusFilter: Filter<RoomsStatusFilter> = [
  // { label: "All", value: "All" },
  { label: "Link Up", value: "Online" },
  { label: "Link Error", value: "Offline" },
  { label: "Monitoring Stalled", value: "Monitoring Stalled" },
  { label: "Monitoring Paused", value: "Monitoring Paused" },
  { label: "Monitoring Triggers Paused", value: "Monitoring Triggers Paused" },
  { label: "API Error", value: "API Error" },
  { label: "Login Error", value: "Login Error" },
  { label: "In a Call", value: "In a Call" },
];

export const meetingsStatusFilter: Filter<MeetingsStatusFilter> = [
  { label: "Scheduled", value: "Scheduled" },
  { label: "In Progress", value: "InProgress" },
  { label: "Completed", value: "Completed" },
  { label: "Cancelled", value: "Cancelled" },
  { label: "Failed", value: "Failed" },
];

export const ticketsPriorityFilter: Filter<TicketsPriorityFilter> = [
  { label: "P1 - Critical", value: Priority.Critical },
  { label: "P2 - Major", value: Priority.Major },
  { label: "P3 - Minor", value: Priority.Minor },
  { label: "P4 - Informational", value: Priority.Informational },
];

export const accountsStatusFilter: Filter<AccountsStatusFilter> = [
  // { label: "All", value: "All" },
  { label: "Link Up", value: "Online" },
  { label: "Link Error", value: "Offline" },
  { label: "Monitoring Stalled", value: "Monitoring Stalled" },
  { label: "Monitoring Paused", value: "Monitoring Paused" },
  { label: "API Error", value: "API Error" },
  { label: "Login Error", value: "Login Error" },
  { label: "In a Call", value: "In a Call" },
];

export const countriesStatusFilter: Filter<CountriesStatusFilter> = [
  // { label: "All", value: "All" },
  { label: "Link Up", value: "Online" },
  { label: "Link Error", value: "Offline" },
  { label: "Monitoring Stalled", value: "Monitoring Stalled" },
  { label: "Monitoring Paused", value: "Monitoring Paused" },
  { label: "API Error", value: "API Error" },
  { label: "Login Error", value: "Login Error" },
  { label: "In a Call", value: "In a Call" },
];

export const locationsStatusFilter: Filter<LocationsStatusFilter> = [
  // { label: "All", value: "All" },
  { label: "Link Up", value: "Online" },
  { label: "Link Error", value: "Offline" },
  { label: "Monitoring Stalled", value: "Monitoring Stalled" },
  { label: "Monitoring Paused", value: "Monitoring Paused" },
  { label: "Monitoring Triggers Paused", value: "Monitoring Triggers Paused" },
  { label: "API Error", value: "API Error" },
  { label: "Login Error", value: "Login Error" },
  { label: "In a Call", value: "In a Call" },
];

export const workflowsTypeFilter: Filter<WorkflowsTypeFilter> = [
  { label: "Action", value: "Action" },
  { label: "Automation", value: "Automation" },
  { label: "Healing", value: "Healing" },
];

export const statusFilters: {
  [K in UserWidgetType | UserOtherType]: Filter<FilterDefinitions[K]["status"]>;
} = {
  Devices: devicesStatusFilter,
  Rooms: roomsStatusFilter,
  Meetings: meetingsStatusFilter,
  Tickets: ticketsPriorityFilter,
  Accounts: accountsStatusFilter,
  Countries: countriesStatusFilter,
  Locations: locationsStatusFilter,
  Workflows: [],
  AuditTrails: [],
  Triggers: [],
  Users: [],
  DeviceCatalog: [],
};

type FilterTitles = {
  [T in FilterTypes]:
    | string
    | { [K in UserWidgetType | UserOtherType]?: string };
};
export const filterTitles: FilterTitles = {
  status: {
    Devices: "Count by realtime status",
    Rooms: "Count by realtime status",
    Meetings: "Count by realtime status",
    Tickets: "Priority",
  },
  vip: "High Importance",
  public: "Public Room",
  service: { Devices: "Monitoring Service", Rooms: "Active" },
  source: "Monitoring Source",
  active: "Active",
  assignee: "Assignee",
  other: "Other meeting properties",
  purpose: "Purpose",
  time: "Time",
  type: { Meetings: "Type", Rooms: "Room Type", Devices: "Type" },
  management: "Room Management",
  state: "Status",
  target: "Target",
  ucPlatform: "UC Platform",
  operatingSystem: "Operating System",
  cloudConnector: "Cloud Connector",
  consumption: "Consumption",
  email: "Email",
  firstName: "Firstname",
  lastName: "Lastname",
  timeServiceExpiration: "Room Service Contract Expiration",
  timeLeaseExpiration: "Lease Expiration",
  timeWarrantyExpiration: "Warranty Expiration",
  "role.id": "Role",
  accountId: "Account",
  "room.location.id": "Location",
  "room.location.country": "Country",
  "room.location.name": "Location",
  "location.country": "Country",
  "details.roomType": "Room Type",
  "room.details.roomType": "Room Type",
  "start.after": "Start",
  "end.before": "End",
  "scheduledMeeting.meetingSource": "Source",
  "scheduledMeeting.producerService": "Service",
  "room.id": "Room",
  "device.name": "Device Name",
  priority: "Priority",
  workflow: "Has Workflow",
  applicableOnly: "Applicable Only",
  city: "City",
  action: "Action",
  producerIds: "producerIds",
  country: "country",
  deviceType: "deviceType",
  category: "category",
  manufacturer: "manufacturer",
  tags: "Tags",
};

export const isFilterWithPayload = (
  widgetType: UserWidgetType,
  filterType: FilterTypes,
  filterValue: string
) => {
  // Generic filters with payload, applicable for all type of widget
  if (
    filterType === "status" ||
    (filterType.startsWith("time") &&
      (filterValue as MeetingsTimeFilter) === "Custom time period") ||
    filterType === "tags"
  ) {
    return true;
  }
  // Specifics payload for each type
  if (widgetType === "Devices") {
    if (
      filterType === "source" ||
      filterType === "service" ||
      filterType === "deviceType"
    )
      return true;
  }
  if (widgetType === "Meetings") {
    if (
      filterType === "producerIds" ||
      filterType === "purpose" ||
      filterType === "scheduledMeeting.meetingSource" ||
      filterType === "type"
    )
      return true;
  }
  if (widgetType === "Tickets") {
    if (filterType === "priority") return true;
  }
  if (filterType === "target") return true;
  if (widgetType === "Rooms") {
    if (filterType === "details.roomType") return true;
    if (filterType === "location.country") return true;
  }
  return false;
};
